import { Character } from '@storyverse/shared'
import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

interface CharactersState {
    characters: Character[]
    activeCharacterId: string | null | undefined // undefined = none, null = new, string = id
    setCharacters: (characters: Character[]) => void
    addCharacter: (character: Character) => void
    updateCharacter: (character: Character) => void
    removeCharacter: (id: string) => void
    setActiveCharacterId: (id: string | null | undefined) => void
}

export const useCharactersStore = create<CharactersState>()(
    devtools((set) => ({
        characters: [],
        activeCharacterId: undefined, // Default to none selected
        setCharacters: (characters) => set({ characters }),
        addCharacter: (character) => set((state) => ({ characters: [...state.characters, character] })),
        updateCharacter: (updated) => set((state) => ({
            characters: state.characters.map(c => c.id === updated.id ? updated : c)
        })),
        removeCharacter: (id) => set((state) => ({
            characters: state.characters.filter(c => c.id !== id),
            activeCharacterId: state.activeCharacterId === id ? undefined : state.activeCharacterId
        })),
        setActiveCharacterId: (id) => set({ activeCharacterId: id }),
    }))
)
